import type { ResumeData } from "@reactive-resume/schema";
import { useMutation } from "@tanstack/react-query";
import type { AxiosResponse } from "axios";

import { axios } from "@/client/libs/axios";

export const parseResumeFile = async (file: File): Promise<ResumeData> => {
  const formData = new FormData();
  formData.append('file', file);

  const response = await axios.post<ResumeData, AxiosResponse<ResumeData>, FormData>(
    "/resume/parser/parse",
    formData,
    {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    }
  );

  return response.data;
};

export const useParseResume = () => {
  const {
    error,
    isPending: loading,
    mutateAsync: parseResumeFn,
  } = useMutation({
    mutationFn: parseResumeFile,
  });

  return { parseResume: parseResumeFn, loading, error };
};